// store/auth.js (Pinia Store)
import { defineStore } from 'pinia';

// Access the environment variable using process.env
const baseUrl = process.env.VUE_APP_API_URL + "/auth/login/";

export const useAuthStore = defineStore({
  id: 'auth',
  state: () => ({
    user: null,
    returnUrl: null, // URL to redirect after login
  }),

  actions: {
    // Login action
    async login(username, password, router) {
      try {
        // Call the API using fetch
        const response = await fetch(baseUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ username, password }),
        });

        const data = await response.json();

        // If login is successful, store user and token
        if (data.message == "Login successful") {
          this.user = data.card_id;

          // Save token to localStorage (or sessionStorage)

          localStorage.setItem('card_id', data.user.card_id);
          localStorage.setItem('token', data.token);


          if (data.user.Efilling_statusID !== null && data.user.Efilling_statusID !== undefined) {

            router.push(this.returnUrl || '/progress');

          } else {

            router.push(this.returnUrl || '/form');

          }

          return true;  // Indicate successful login
        } else {
          throw new Error(data.message || 'Login failed');
        }
      } catch (err) {
        // Handle the error (log it, show message to user)
        // console.error('Login failed:', err);

        // Redirect to login page if login fails
        router.push('/login');

        return false;  // Indicate failure
      }
    },

    // Logout action
    logout(router) {
      this.user = null; // Clear user state
      localStorage.removeItem('token'); // Remove token from storage
      router.push('/login'); // Redirect to login page
    },

    // Optionally, you can add more actions like fetching user details after login
  },
});
